import React from 'react';
import styled from 'styled-components';
import { typography } from '../../../styled';
import { BookingQuizCategory, CATEGORY_ICONS } from '..';

const {
  serif: {
    card: { H1 }
  }
} = typography;

type Props = {
  text: string;
  category?: BookingQuizCategory;
};

const Question = ({ text, category }: Props) => (
  <QuestionContainer>
    {category && CATEGORY_ICONS[category]}
    <H1>{text}</H1>
  </QuestionContainer>
);

export default Question;

const QuestionContainer = styled.div`
  text-align: center;
  margin: 3em 0;
`;
